import { useContext } from 'react';
import { IShowAnimationContext, ShowAnimationContext } from './ShowAnimationProvider';


// light wrapper around AnimationCompleteProvider so we can use it as a custom hook
const useAnimationComplete = () => {
    return useContext(ShowAnimationContext) as IShowAnimationContext;
}

export default useAnimationComplete;